"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssociatedProductComponents = exports.updateProductService = exports.createProductService = exports.deleteProductService = exports.getProducts = void 0;
const api_1 = require("@/services/api");
const ENDPOINT = "/products";
function getProducts() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}?order[updatedAt]=DESC`)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`[Products Error]: ${error}`);
    });
}
exports.getProducts = getProducts;
function deleteProductService(productId) {
    return api_1.axiosInstance
        .delete(`${ENDPOINT}/${productId}`)
        .then((response) => {
        response.status;
    })
        .catch((error) => {
        throw new Error(`[Products Error]: ${error}`);
    });
}
exports.deleteProductService = deleteProductService;
function createProductService(productName) {
    return api_1.axiosInstance
        .post(ENDPOINT, { name: productName })
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new Error(`[Products Error]: ${error}`);
    });
}
exports.createProductService = createProductService;
function updateProductService(productId, productName) {
    return api_1.axiosInstance
        .put(`${ENDPOINT}/${productId}`, { name: productName })
        .then((response) => {
        return response.status;
    })
        .catch((error) => {
        throw new Error(`[Products Error]: ${error}`);
    });
}
exports.updateProductService = updateProductService;
function getAssociatedProductComponents(productId) {
    return api_1.axiosInstance
        .get(`${ENDPOINT}/${productId}/components`)
        .then((response) => {
        return response.data[0];
    })
        .catch((error) => {
        throw new Error(`[Products Error]: ${error}`);
    });
}
exports.getAssociatedProductComponents = getAssociatedProductComponents;
